import { render, staticRenderFns } from "./RewardsPoints.vue?vue&type=template&id=80a721d8&scoped=true&"
import script from "./RewardsPoints.vue?vue&type=script&lang=js&"
export * from "./RewardsPoints.vue?vue&type=script&lang=js&"
import style0 from "./RewardsPoints.vue?vue&type=style&index=0&id=80a721d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a721d8",
  null
  
)

export default component.exports